module.exports = __webpack_public_path__ + "static/media/GAMKONORA_ch5_20210921062651_T.2c4aa45c.jpg";